/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactstierfree2Inputs */

const en_artifactstierfree2 = /** @type {(inputs: Artifactstierfree2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const pt_artifactstierfree2 = /** @type {(inputs: Artifactstierfree2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grátis`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Artifactstierfree2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactstierfree2 = /** @type {((inputs?: Artifactstierfree2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactstierfree2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactstierfree2(inputs)
	return pt_artifactstierfree2(inputs)
});
export { artifactstierfree2 as "artifactsTierFree" }